import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader'; // Import NgxUiLoaderService
import { CommonService } from 'src/app/services/api/common.service';
import { ToastrService } from 'ngx-toastr';
import {
  Router,
  NavigationEnd,
  ActivatedRouteSnapshot,
  NavigationStart,
} from '@angular/router';
import { environment } from '../../../environments/environment';
import { NgClass, NgIf } from '@angular/common';
import { SchoolData } from 'src/app/models/schoolUser';
import moment from 'moment';
import { cu } from '@fullcalendar/core/internal-common';

declare var $: any;

@Component({
  selector: 'app-swich-back-to-python',
  templateUrl: './swich-back-to-python.component.html',
  styleUrls: ['./swich-back-to-python.component.scss'],
  standalone: true,
  imports: [NgIf],
})
export class SwichBackToPythonComponent implements OnInit {
  @Input() fromComp: any;
  @Input() jobOnly: any;

  currentUrl!: string;
  pageLoad: Boolean = false;
  isAfterApril30: boolean = false;
  public schoolProps!: SchoolData;
  windowLocation: any;
  showSwitchBack: boolean = false;
  showSwitchBackSection = false;

  constructor(
    private ngxService: NgxUiLoaderService,
    private commonService: CommonService,
    private toastr: ToastrService,
    private _router: Router
  ) {
    this.windowLocation = window.location.href.split('/');
    const routeUrl = this._router.url;
    if (routeUrl !== '/login' && routeUrl !== '/register' && routeUrl !== '/') {
      this.schoolProps = JSON.parse(localStorage.getItem('userData') || '{}');
      const currentDate = new Date(
        this.schoolProps.mixpanel_data?.created_at_formated
      );
      const targetDate = new Date('2025-04-30'); // April 30, 2025
      this.isAfterApril30 = currentDate >= targetDate;
    }
  }

  ngOnInit(): void {
    this.schoolProps = JSON.parse(localStorage.getItem('userData') || '{}');
    this.showSwitchBackSection = this._router.url.includes('school');

    // this.route.events.subscribe((event: any) => {

    //   if (event instanceof NavigationEnd) {
    //     const segments: string[] = [];
    //     let currentRoute: ActivatedRouteSnapshot = this.route.routerState.root.snapshot;
    //     while (currentRoute) {
    //       const path = currentRoute.routeConfig?.path;
    //       if (path && path !== '') { // Filter out these empty paths
    //         segments.push(path);
    //       }
    //       currentRoute = currentRoute.children[0];
    //     }
    //     const rawPath = segments.join('/');
    //     this.pageLoad = rawPath === 'login' || rawPath === 'register' ? false : true;
    //     console.log(this.jobOnly)
    //     console.log(this.pageLoad)

    //   }
    // });
    // this.pageLoad = this.jobOnly != null ? true : false;
    this._router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.routerChangeMethod(event.url);
      }
    });
    $(document).ready(function () {
      $('[data-bs-toggle="tooltip"]').tooltip();
    });
  }

  routerChangeMethod(url: any) {
    this.showSwitchBackSection = this._router.url.includes('school');

    this.windowLocation = window.location.href.split('/');
    const routeUrl = this._router.url;
    if (routeUrl !== '/login' && routeUrl !== '/register') {
      this.schoolProps = JSON.parse(localStorage.getItem('userData') || '{}');
      const currentDate = new Date(
        this.schoolProps.mixpanel_data?.created_at_formated
      );
      const targetDate = new Date('2025-04-30'); // April 30, 2025
      this.isAfterApril30 = currentDate >= targetDate;
    }
    // else if(routeUrl === '/login' || routeUrl === '/register' || routeUrl === '/') {
    //   this.isAfterApril30 = false;
    // }
    this.showSwitchBack = this.isAfterApril30;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.pageLoad = this.jobOnly == null || this.jobOnly == true ? false : true;
    this.showSwitchBackSection = this._router.url.includes('school');

    this.windowLocation = window.location.href.split('/');
    const routeUrl = this._router.url;
    if (routeUrl !== '/login' && routeUrl !== '/register') {
      this.schoolProps = JSON.parse(localStorage.getItem('userData') || '{}');
      const currentDate = new Date(
        this.schoolProps.mixpanel_data?.created_at_formated
      );
      const targetDate = new Date('2025-04-30'); // April 30, 2025
      this.isAfterApril30 = currentDate >= targetDate;
    }
    // else if(routeUrl === '/login' || routeUrl === '/register' || routeUrl === '/') {
    //   this.isAfterApril30 = false;
    // }
    this.showSwitchBack = this.isAfterApril30;
  }

  // routerChangeMethod(url: string) {
  //   this.pageLoad = this.jobOnly != null ? true : false;
  // }

  switchBack() {
    this.ngxService.start();
    this.commonService.switchBackToPython().subscribe({
      next: (res: any) => {
        this.ngxService.stop();
        if (res) {
          window.location.replace(environment.apiUrl);
        } else {
          console.log('error in the response', res);
        }
      },
      error: (err: any) => {
        console.log(err);
        this.toastr.error(err.message);
        this.ngxService.stop();
      },
    });
  }
}
